// Lightens a #rrggbb hex color towards white by the given percent (0-1).
// Falls back to the original value for anything that isn't a plain 6-digit hex.
export const lightenColor = (hex, percent) => {
  const match = /^#([0-9a-f]{6})$/i.exec(hex || '');
  if (!match) {
    return hex;
  }

  const num = parseInt(match[1], 16);
  const mix = channel => Math.round(channel + (255 - channel) * percent);

  const r = mix((num >> 16) & 0xff);
  const g = mix((num >> 8) & 0xff);
  const b = mix(num & 0xff);

  return `rgb(${r}, ${g}, ${b})`;
};
